import type { FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import { EVO_STARS_VALUES, NO_STAR_RATING_VALUE } from '@/app/common/filters/core/starsValues.ts';
import { starsWrappedText } from '@/app/common/filters/core/starsLabel.ts';
import Stars from '@/app/common/components/Stars/index.tsx';
import { createFilterTilesMain } from '@/app/common/filters/surfaces/forms/tiles/createFilterTilesMain.tsx';

const TILE_GLYPH_SIZE = 20;

const isRated = (option: FilterDataOption) => option.value !== NO_STAR_RATING_VALUE;

// Data order is descending with "no star rating" last; the grid reads ascending.
const ratedAscendingThenUnrated = (options: FilterDataOption[]) => [
  ...options
    .filter(isRated)
    .slice()
    .sort((a, b) => Number(a.value) - Number(b.value)),
  ...options.filter((option) => !isRated(option)),
];

// One row of categories, so the unrated option lands alone on the second row and fills it.
export const StarsAllFiltersGrid = createFilterTilesMain({
  idPrefix: 'stars-tile',
  perRow: { mobile: EVO_STARS_VALUES.length, desktop: EVO_STARS_VALUES.length },
  variant: 'inline',
  sortOptions: ratedAscendingThenUnrated,
  renderContent: (option) => (
    <>
      {option.label}
      {isRated(option) && <Stars stars={1} size={TILE_GLYPH_SIZE} color="currentColor" decorative={true} />}
    </>
  ),
  // The tile shows a digit and a single glyph, so name it the way the overlay row announces itself.
  ariaLabel: (option, t, lang) =>
    isRated(option) ? starsWrappedText([Number(option.value)], t, lang).text : option.label,
});
